import React, { useEffect, useRef, useState } from "react";
import backgroundImage from "../assets/bg-image.png";
import CustomButton from "./CustomButton";
import Qrcodegenerator from "./QRCodeGenerator";
import logoimg from "../assets/ddicon.png";
import MenuScreen from "./MenuScreen";
import { userLoginSignup } from "../services/services";

let resolution = window.RESOLUTION;

const LoginOTP = ({ navigate }) => {
  const [state, setState] = useState({
    selectedElementIndx: 0,
    otpValues: Array(6).fill(""),
  });

  const [isLoading, setIsLoading] = useState(false);

  const { selectedElementIndx, otpValues } = state;
  const inputRefs = useRef([]);
  const buttonRef = useRef(null); // Reference for the button

  const LoginOtpKeyHandler = (event) => {
    if (selectedElementIndx === -1) return;

    switch (event.keyCode) {
      case 37: // Left arrow
        if (selectedElementIndx > 0) {
          setState((prevState) => ({
            ...prevState,
            selectedElementIndx: prevState.selectedElementIndx - 1,
          }));
        }
        break;
      case 39: // Right arrow
        if (selectedElementIndx < 5) {
          setState((prevState) => ({
            ...prevState,
            selectedElementIndx: prevState.selectedElementIndx + 1,
          }));
        }
        break;
      case 40: // Down arrow
        if (selectedElementIndx < 6) {
          setState((prevState) => ({
            ...prevState,
            selectedElementIndx: 6,
          }));
          inputRefs.current[selectedElementIndx]?.blur();
          buttonRef.current?.focus(); // Move focus to button
        }
        break;
      case 38: // Up arrow
        setState((prevState) => ({
          ...prevState,
          selectedElementIndx: 0,
        }));
        break;
      case 13: // Enter
        if (selectedElementIndx === 6) {
          loadData();
          // navigate("HomePage");
        }
        break;
      default:
        break;
    }
  };

  console.log("testOtp", otpValues);

  useEffect(() => {
    const filledOtp = otpValues.join("");
    console.log("testOtp", filledOtp); // Debug log
    
    if (filledOtp.length === 6) {
      console.log("OTP complete, calling loadData");
      loadData();
    }
  }, [otpValues]);

  const handleInputChange = (event, index) => {
    const value = event.target.value;

    if (/^[0-9]$/.test(value)) {
      // Ensure only single digit values are allowed
      const newOtpValues = [...otpValues];
      newOtpValues[index] = value;

      setState((prevState) => ({
        ...prevState,
        otpValues: newOtpValues,
      }));

      const getOTP = newOtpValues.join("");

      localStorage.setItem("getOTP", getOTP);

      if (index < 5 && value.length === 1) {
        setState((prevState) => ({
          ...prevState,
          selectedElementIndx: index + 1,
        }));
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  const loadData = async () => {
    if (isLoading) return;
  
    setIsLoading(true);

    const myHeaders = {
      Version: localStorage.getItem("firmwareVersion"),
      devicetype: "11",
      Deviceid: localStorage.getItem("sdkVersion"),
      Devicetoken:
        localStorage.getItem("idValue"),
      Devicemodel: localStorage.getItem("modelName"),

      "Content-Type": "application/json",
    };

    const raw = {
      mobile: localStorage.getItem("mobileNo"),
      country_code: "+91",
      otp: localStorage.getItem("getOTP"),
    };

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(raw),
    };

    try {
      // const response = await fetch(
      //   // "https://devapi.pb-online.co.in/api/V1/userLoginSignup",
      //   "https://qanodeapi.pb-online.co.in/api/V1/userLoginSignup",
      //   requestOptions
      // );
      
      const response = await userLoginSignup(JSON.stringify(raw));
      if (response.ok) {
        console.log("response 127",response)
        // <LoginOTP navigate={navigateToScreen} />;
        // navigate("LoginOtpPage", {});
      }
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      console.log("result 134",result)
      localStorage.setItem("JWTToken", result.data.jwt);
      localStorage.setItem("user_details",JSON.stringify(result.data.user_details));
      const userData = localStorage.getItem("user_details");
      // localStorage.setItem("userData", JSON.parse(userData));
      if (result.status) {
       // MenuScreen.ReseTfocus(4);
       console.log(result, "login result")
        navigate("WhoWatching", {});
        // navigate("HomePage", {});
        // navigate("MyProfile", {});
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputFocus = (index) => {
    setState((prevState) => ({
      ...prevState,
      selectedElementIndx: index,
    }));
  };

  useEffect(() => {
    window.addEventListener("keydown", LoginOtpKeyHandler);
    return () => {
      window.removeEventListener("keydown", LoginOtpKeyHandler);
    };
  }, [selectedElementIndx]);

  useEffect(() => {
    if (selectedElementIndx < 6) {
      inputRefs.current[selectedElementIndx]?.focus();
    }
  }, [selectedElementIndx]);

  const backgroundStyle = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    minHeight: "100vh",
    height: "1080px",
  };

  const logobox = {
    backgroundImage: `url(${logoimg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    width: "96px",
    height: "80px",
    position: "relative",
    margin: "auto",
    top: "2rem",
  };

  const layertransparent = {
    width: "100%",
    height: "100%",
    background: "#000",
    opacity: "0.9",
    position: "absolute",
  };

  const languageselection = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "80%",
    backgroundColor: "#000",
    color: "#fff",
    width: "90%",
    margin: "5vh auto",
  };

  const languagegrid = {
    width: "100%",
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "1rem",
  };

  const applanguage = {
    textAlign: "center",
    fontSize: "3rem",
    marginBottom: "1rem",
  };

  const leftContainer = {
    width: "72vh",
  };

  const rightContainer = {
    width: "100vh",
  };

  const dividercontainer = {
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    margin: "62px 0px",
    height: "80%",
  };

  const dividerline = {
    flexGrow: "1",
    height: "30vh",
    backgroundColor: "#ccc",
    width: "2px",
  };

  const dividertext = {
    margin: "0 10px",
    color: "#fff",
    fontWeight: "bold",
    padding: "20px",
  };

  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    backgroundColor: "#000",
    width: "80%",
  };

  const cardStyle = {
    padding: "40px",
    borderRadius: "10px",
    textAlign: "center",
    width: "71%",
    height: "80%",
  };

  const titleStyle = {
    color: "#FFF",
    marginBottom: "10px",
  };

  const subtitleStyle = {
    color: "#CCC",
    marginBottom: "20px",
  };

  const tabContainerStyle = {
    display: "flex",
    justifyContent: "center",
    marginBottom: "20px",
    marginTop: "3rem",
  };

  const inputContainerStyle = {
    display: "flex",
    alignItems: "center",
    marginBottom: "0",
    marginTop: "0rem",
  };

  const inputStyle = {
    flex: 1,
    padding: "10px",
    border: "1px solid #444",
    backgroundColor: "#333",
    color: "#FFF",
    marginLeft: "1rem",
    height: "3rem",
    width: "6vh",
    borderRadius: "5px",
    textAlign: "center",
    fontSize: "1.5rem",
  };

  const inputFocusStyle = {
    border: "2px solid #FF6F00",
  };

  const footerTextStyle = {
    color: "#CCC",
    position: "relative",
    top: "19vh",
  };

  const linkStyle = {
    color: "#FF6F00",
    textDecoration: "none",
  };

  const infoStyle = {
    color: "#CCC",
    marginBottom: "20px",
  };

  const buttonContainer = {
    display: "",
  };

  const buttonFocusStyle = {
    border: "2px solid #FF6F00",
  };

  return (
    <div style={backgroundStyle}>
      <div style={layertransparent}>
        <div style={logobox}></div>
        <div style={languageselection}>
          <h1 style={applanguage}>Welcome to DDs World of Entertainment</h1>
          <div style={languagegrid}>
            <div style={leftContainer}>
              <Qrcodegenerator navigate={navigate} />
            </div>
            <div style={dividercontainer}>
              <div style={dividerline}></div>
              <span style={dividertext}>OR</span>
              <div style={dividerline}></div>
            </div>
            <div style={rightContainer}>
              <div style={containerStyle}>
                <div style={cardStyle}>
                  <h1 style={titleStyle}>Sign with Mobile or Email</h1>
                  <p style={subtitleStyle}>
                    Enter your mobile number or email to continue
                  </p>
                  <div style={tabContainerStyle}>
                    <div style={inputContainerStyle}>
                      {[...Array(6)].map((_, index) => (
                        <input
                          key={index}
                          type="text"
                          maxLength="1"
                          value={otpValues[index]}
                          style={{
                            ...inputStyle,
                            ...(selectedElementIndx === index
                              ? inputFocusStyle
                              : {}),
                          }}
                          ref={(ref) => (inputRefs.current[index] = ref)}
                          onChange={(e) => handleInputChange(e, index)}
                          onFocus={() => handleInputFocus(index)}
                        />
                      ))}
                    </div>
                  </div>
                  <p style={infoStyle}>Resend OTP in 25s</p>
                  <div style={buttonContainer}>
                    <CustomButton
                      ref={buttonRef}
                      navigateTo="/login"
                      fontSize={resolution === "FHD" ? "24px" : "18px"}
                      defaultSelected={selectedElementIndx === 6}
                      width={resolution === "FHD" ? "32vw" : "32vw"}
                      height={resolution === "FHD" ? "7vh" : "7vh"}
                      left={resolution === "FHD" ? "-16vw" : "-16vw"}
                      right={resolution === "FHD" ? "0vw" : "0vw"}
                      style={selectedElementIndx === 6 ? buttonFocusStyle : {}}
                    >
                      Proceed
                    </CustomButton>
                  </div>
                  <p style={footerTextStyle}>
                    Having Trouble Logging in? Please visit{" "}
                    <a href="https://www.xyz.com" style={linkStyle}>
                      www.xyz.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginOTP;
